import { useState } from 'react'

export type SetupProgramtStep = 'program' | 'more_detail' | 'plan' | 'subscribe' | 'invite'

interface ISetupProgramWizard {
  step: SetupProgramtStep
  steps: SetupProgramtStep[]
  nextStep: (amount?: number) => void
  previousStep: (amount?: number) => void
  reset: () => void
}

export const useSetupProgramWizard = (): ISetupProgramWizard => {
  const [stepIndex, setStepIndex] = useState<number>(0)
  const steps: SetupProgramtStep[] = ['program', 'more_detail', 'plan', 'subscribe', 'invite']

  const nextStep = (amount: number = 1): void => {
    if (typeof stepIndex !== 'undefined' && stepIndex < steps.length - 1 && !isNaN(amount)) {
      setStepIndex(stepIndex + amount)
    }
  }
  const previousStep = (amount: number = 1): void => {
    if (stepIndex > 0 && !isNaN(amount)) {
      setStepIndex(stepIndex - amount)
    }
  }
  const reset = (): void => {
    setStepIndex(0)
  }
  return {
    step: steps[stepIndex],
    steps,
    nextStep,
    previousStep,
    reset,
  }
}
